export interface IFieldEidosCsca {
  market:string,
  country:string,
  searchAddress:string,
  address:string,
  state:string,
  county:string,
  city:string,
  zip:string,
  zip4:string,
  longitude:string,
  latitude:string
}

export type IEidosCscaFieldKey =
  | 'market'
  | 'country'
  | 'addressSearch'
  | 'state'
  | 'county'
  | 'address'
  | 'city'
  | 'zip'
  | 'zip4';

export type IEidosCscaColumns = Partial<Record<IEidosCscaFieldKey, string>>;

export const EMPTY_FIELD_CSCA:IFieldEidosCsca = { 
  market:'', 
  country:'', 
  searchAddress:'',
  address:'', 
  state:'', 
  county:'',
  city:'', 
  zip:'', 
  zip4:'', 
  longitude:'', 
  latitude:'' 
};